import * as DocumentPicker from "expo-document-picker";
import * as ImagePicker from "expo-image-picker";
import { useFocusEffect, useRouter } from "expo-router";

import { useSaveFormContext } from "~/components/SaveForm/shared";
import { useCurrentAccount } from "~/hooks/useCurrentAccount";

export default function LinkPreviewPage() {
  const { setValue, getValues } = useSaveFormContext();
  const { replace } = useRouter();
  const saveType = getValues("type");
  const { slug } = useCurrentAccount();
  useFocusEffect(() => {
    console.log("running");
    (async () => {
      switch (saveType) {
        case "FILE": {
          try {
            const result = await DocumentPicker.getDocumentAsync();

            if (!result.canceled) {
              const asset = result.assets[0];
              setValue("fileMeta", {
                name: asset?.name ?? "",
                uri: asset?.uri ?? "",
                mimeType: asset?.mimeType ?? "",
                size: asset?.size ?? 0,
                file: asset.file,
              });
            }
          } catch (e) {
            console.error(e);
          }
          return;
        }
        case "MEDIA": {
          try {
            await ImagePicker.requestMediaLibraryPermissionsAsync();
            const result = await ImagePicker.launchImageLibraryAsync({
              mediaTypes: ImagePicker.MediaTypeOptions.All,
              presentationStyle:
                ImagePicker.UIImagePickerPresentationStyle.FORM_SHEET,
            });

            if (!result.canceled) {
              const asset = result.assets[0];
              setValue("mediaMeta", {
                assetId: asset.assetId ?? "",
                uri: asset?.uri ?? "",
                type: asset.type ?? "image",
                duration: asset.duration ?? 0,
                fileName: asset.fileName ?? "",
                fileSize: asset.fileSize ?? 0,
                height: asset.height,
                width: asset.width,
              });
            }
          } catch (e) {
            console.error(e);
          }
          return;
        }

        case "URL": {
          replace({
            pathname: "/(app)/(authenticated)/[account]/link",
            params: {
              account: slug,
            },
          });
          return;
        }
        default: {
          throw new Error(`${saveType} not supported`);
        }
      }
    })();
  });

  return null;
}
